import React from 'react';
import {intlShape, FormattedMessage} from 'react-intl';
import {compose} from 'redux';
import {types as sdkTypes} from '../../../../util/sdkLoader';

import {withViewport} from '../../../../util/contextHelpers';
import {
  NamedLink,
} from '../../../../components';
import css from './RedirectToOfferPage.module.css';
import {formatMoney} from '../../../../util/currency';

const {Money} = sdkTypes;

const RedirectToOfferPage = (props) => {
  const {
    intl,
    priceAmount,
    providerDisplayName,
    listingId,
    bookingParams,
  } = props;
  const pendingMessage = (
    <FormattedMessage id="ActivityFeed.ProviderOfferProposalReplacement" values={{
      providerDisplayName,
      price: formatMoney(
        intl,
        new Money(priceAmount, "EUR"),
        true,
      ),
    }}/>
  );
  const acceptMessage = intl.formatMessage({id: 'ActivityFeed.pendingProposalAccept'});
  const counterProposalMessage = intl.formatMessage({
    id: 'ActivityFeed.pendingProposalCounterProposal',
  });
  const {startTime, endTime,bookingDate } = bookingParams;
  if (!listingId) return null;

  return (
    <>
      <div className={css.pending}>
        <p className={css.pendingContent}>{pendingMessage}</p>
        <div className={css.pendingButtons}>
          <NamedLink
            className={css.pendingDetailsButton}
            name="ListingPage"
            params={{id: listingId ?? '', slug: ''}}
            to={{ search: `?adults=10&bookingDate=${encodeURI(bookingDate)}&startTime=${startTime}&endTime=${endTime}` }}
          >
            {counterProposalMessage}
          </NamedLink>
          <NamedLink
            className={css.pendingDetailsButton}
            name="ListingPage"
            params={{id: listingId ?? '', slug: ''}}
            to={{ search: `?adults=10&bookingDate=${encodeURI(bookingDate)}&startTime=${startTime}&endTime=${endTime}` }}
          >
            {acceptMessage}
          </NamedLink>
        </div>
      </div>
    </>
  );
};

RedirectToOfferPage.defaultProps = {
  intl: null,

};

RedirectToOfferPage.propTypes = {
  intl: intlShape.isRequired,

};

export default compose(withViewport)(RedirectToOfferPage);
